// extracted by mini-css-extract-plugin
export default {"menu":"MegaMenuDesktop_menu__dAmDV","megadrop":"MegaMenuDesktop_megadrop__is0E7","left-icon":"MegaMenuDesktop_left-icon__oO3uu"};